import { addItemsToCategories } from '../api/items';

export const addItemNodes = ({ categories, itemNos, catalogId }) =>
  addItemsToCategories({
    catalogId,
    categories,
    itemNos,
  });
